import Iodine from '@caneara/iodine';
const instance = new Iodine();

let syncShippingAddress = true;
let readyToPay = false;

instance.rule('emailConfirmation', (value, param) => {
  return value === (document.getElementById(param) ? document.getElementById(param).value : 'mew');
});
instance.setErrorMessage('emailConfirmation', "Email confirmation needs to match email");

instance.rule('requiredShipping', (value, param) => {
  if (!syncShippingAddress) {
    return value.length > 0;
  }
  return true;
});
instance.setErrorMessage('requiredShipping', "This field is required");

instance.setErrorMessage('regexMatch', 'Invalid format');
instance.setErrorMessage('required', 'This field is required');

// filter keyword input delay
function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

function validateForm(e, form, opts) {

  const submitButtons = form.querySelectorAll('[type="submit"]');
  var isFormValid = true;

  form.querySelectorAll('input, select, textarea').forEach(el => {

    if (el.getAttribute('type') == 'submit' ||
        el.getAttribute('type') == 'button' ||
        el.getAttribute('type') == 'hidden') {
      return;
    }
    const rules = opts.rules[el.name] ?? [];

    const isValid = validateInput(el, rules, form);
    if (!isValid) isFormValid = false;

  });

  // submitButtons.forEach(el => {
  //   el.disabled = !!(!isFormValid);
  // });

  if (!isFormValid) {
    if (e) e.preventDefault();
    return false;
  } else if (e) {
    form.classList.add('form--disabled');

    const loader = document.createElement('div');
    loader.setAttribute('class', 'loader');
    loader.innerHTML = '<svg class="circular-loader" viewBox="25 25 50 50" ><circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#ffffff" stroke-width="3" /></svg>';
    form.appendChild(loader);
    // form.querySelectorAll('input, select, textarea').forEach(el => {
    //   el.disabled = !!(true);
    // });
    submitButtons.forEach(el => {
      el.disabled = !!(true);
    });
    return true;
  }

}

function validateInput(input, rules, form, onChange) {

  const isOnChange = onChange ?? false;
  const field = input.closest('.form-group');
  const label = field.querySelector('.form-label') ? field.querySelector('.form-label').innerHTML : 'This field';
  const name = input.getAttribute('name');
  const value = input.value;
  const isTouched = !!input.getAttribute('data-touched');

  var isValid = !!(!rules.length);

  const result = instance.assert(value, rules);

  isValid = result.valid === true;
  const message = result.error;

  if (isTouched || (!isTouched && isValid)) {

    var feedback = field.querySelector('.form-message');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.classList.add('has-error');
      feedback.classList.add('form-message');
      let messages = field.querySelector('.form-messages');
      const controls = input.closest('.form-control');
      if (controls && !messages) {
        messages = document.createElement('div');
        messages.classList.add('form-messages');
        messages.setAttribute('aria-live', 'polite');
        messages.setAttribute('aria-relevant', 'additions removals');
        messages.setAttribute('id', name + 'Errors');
        controls.insertBefore(messages, null);
      }
      if (controls && messages) {
        messages.appendChild(feedback);
      } else if (controls) {
        controls.setAttribute('id', name + 'Errors');
        controls.insertBefore(feedback, null);
      }
    }

    if (isValid) {
      feedback.display = 'none';
      feedback.innerHTML = '';
      feedback.classList.remove('has-error');
      // input.setAttribute('aria-describedby', '');
      field.classList.remove('form-field--has-error');
      field.classList.add('form-field--has-success');
    } else {
      feedback.display = 'block';
      feedback.innerHTML = message;
      feedback.classList.add('has-error');
      // input.setAttribute('aria-describedby', name + 'Message');
      field.classList.add('form-field--has-error');
      field.classList.remove('form-field--has-success');
    }

  } else {

    field.classList.remove('form-field--has-success');
    field.classList.remove('form-field--has-error');

  }

  input.setAttribute('aria-invalid', String(!isValid));

  return isValid;

}

function validate(form, opts) {

  if (form) {

    function runFormValidation(e) {
      validateForm(e, form, opts);
    }

    function runFieldValidation(el) {
      validateInput(el, opts.rules[el.getAttribute('name')] ?? [], form, true);
      validateForm(null, form, opts);
    }

    form.addEventListener('submit', function(e) {
      runFormValidation(e);
    });

    const formFields = form.querySelectorAll('input, select, textarea, .form-field__controls').forEach(el => {

      el.addEventListener('change', (e) => {
        runFieldValidation(el);
        el.setAttribute('data-touched', 'true');
      });

      el.addEventListener('blur', (e) => {
        runFieldValidation(el);
        el.setAttribute('data-touched', 'true');
      });

      el.addEventListener('keydown', delay(function(event) {
        runFieldValidation(el);
      }, 300));

    });

    validateForm(null, form, opts);

  }

}

document.addEventListener('DOMContentLoaded', () => {

  // delivery + shipping address
  function updateAddress() {
    if (syncShippingAddress) {
      document.querySelectorAll('.form-group[data-model="shipping"]').forEach(el => {
        el.style.display = 'none';
      });
      var addressComponents = ['addressLine1', 'addressLine2', 'locality', 'postalCode', 'administrativeArea'];
      for (var i=0; i<addressComponents.length; i++) {
        document.querySelector('[name="shippingAddress\[' + addressComponents[i] + '\]"]').value = document.querySelector('[name="billingAddress\[' + addressComponents[i] + '\]"]').value;
      }
    } else {
      document.querySelectorAll('.form-group[data-model="shipping"]').forEach(el => {
        el.style.display = 'block';
      });
    }
    checkPostcode();
  }

  document.querySelectorAll('[name="shippingAddressSameAsBilling"]').forEach(el => {
    el.addEventListener('change', e => {
      syncShippingAddress = el.checked;
      updateAddress();
    })
  });

  document.querySelectorAll('[data-model="billing"] input, [data-model="billing"] select').forEach(el => {
    el.addEventListener('change', e => {
      updateAddress();
    })
    el.addEventListener('keup', e => {
      updateAddress();
    })
  });

  if (document.querySelector('[name="shippingAddressSameAsBilling"]')) {
    document.querySelector('[name="shippingAddressSameAsBilling"]').dispatchEvent(new Event('change'));
  }

  // validate postcode
  function checkPostcode() {

    if (typeof allowedPostcodes !== 'undefined') {
      let postcode = document.querySelector('[name="shippingAddress[postalCode]"]').value;
      if (syncShippingAddress) postcode = document.querySelector('[name="billingAddress[postalCode]"]').value;
      if (postcode.length >= 4) {
        if (allowedPostcodes.indexOf(postcode) !== -1) {
          document.querySelector('#deliveryOutsideRadius').style.display = 'none';
        } else {
          document.querySelector('#deliveryOutsideRadius').style.display = 'block';
        }
      } else {
        document.querySelector('#deliveryOutsideRadius').style.display = 'none';
      }
    }

  }

  document.querySelectorAll('[name="shippingAddress[postalCode]"]').forEach(el => {
    el.addEventListener('keyup', e => {
      checkPostcode();
    })
  });

  document.querySelectorAll('[name="billingAddress[postalCode]"]').forEach(el => {
    el.addEventListener('keyup', e => {
      if (syncShippingAddress) checkPostcode();
    })
  });

  checkPostcode();


  // terms and conditions
  function checkTerms() {
    let readyToPay = true;
    document.querySelectorAll('.agree-to-proceed').forEach(el => {
      if (!el.checked) readyToPay = false;
    });
    if (document.querySelector('#paymentDetails')) {
      if (readyToPay) {
        // document.querySelector('#paymentDetails').style.display = 'block';
        document.querySelector('#paymentDetails').classList.remove('s_deactivated');
      } else {
        // document.querySelector('#paymentDetails').style.display = 'none';
        document.querySelector('#paymentDetails').classList.add('s_deactivated');
      }
    }
  }

  document.querySelectorAll('.agree-to-proceed').forEach(el => {
    el.addEventListener('change', e => {
      checkTerms();
    })
  });

  checkTerms();


  // payment amount
  document.querySelectorAll('[name="paymentAmount"]').forEach(el => {
    el.addEventListener('change', e => {
      const selectedOption = el.options[el.selectedIndex];
      const paymentType = selectedOption.getAttribute('data-type');
      if (paymentType == 'partial') document.querySelector('.partial-payment-note').style.display = 'block';
      else document.querySelector('.partial-payment-note').style.display = 'block';
    })
  });



  // flash
  document.querySelectorAll('.flash-close').forEach(el => {
    el.addEventListener('click', e => {
      el.parentNode.style.display = 'none';
    })
  });


  // validate form
  validate(document.getElementById('orderForm'), {
    rules: {

      email: ['required', 'email'],
      emailConfirm: ['required', 'email', 'emailConfirmation:emailAddress'],

      'billingAddress[firstName]': ['required'],
      'billingAddress[lastName]': ['required'],
      'billingAddress[fields][addressPhone]': ['required', 'regexMatch:^[0-9 \+\-]+$'],
      'billingAddress[addressLine1]': ['required'],
      'billingAddress[locality]': ['required'],
      'billingAddress[postalCode]': ['required', 'regexMatch:^[0-9]{4,5}$'],
      'billingAddress[administrativeArea]': ['required'],

      'shippingAddress[addressLine1]': ['requiredShipping'],
      'shippingAddress[locality]': ['requiredShipping'],
      'shippingAddress[postalCode]': ['requiredShipping', 'regexMatch:^[0-9]{4,5}$'],
      'shippingAddress[administrativeArea]': ['requiredShipping'],

    }
  });

  document.querySelectorAll('.nameField').forEach((el) => {

    el.addEventListener('keyup', e => {
      const billingFirstName = document.querySelector('[name="billingAddress[firstName]"]').value ?? '';
      const billingLastName = document.querySelector('[name="billingAddress[lastName]"]').value ?? '';
      const billingFullName = billingFirstName + ' ' + billingLastName;
      if (document.querySelector('[name="billingAddress[fullName]"]')) {
        document.querySelector('[name="billingAddress[fullName]"]').value = billingFullName;
      }
    });

  })

});
